import { z } from "zod";

export const waitlistSchema = z.object({
	name: z.string().min(1, { message: "Nome é obrigatório" }),
	email: z
		.string()
		.min(1, { message: "E-mail é obrigatório" })
		.email({ message: "Digite um e-mail válido" }),
});

export type WaitlistFormValues = z.infer<typeof waitlistSchema>;
